import "./quickmenu.scss";
import { type FC } from "react";
import { Link } from "react-router-dom";
import { useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { LAYOUT_QUICK_MENU_TOGGLE } from "../../../Actions/General/LayoutActions";
import { fireEventType } from "../../../Utilities/Generic/ActionsHelper";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    children: string;
    href: string;
    local?: boolean;
    current: boolean;
}

export const QuickMenuItem: FC<Props> = ({
    current,
    local,
    href,
    children,
}) => {
    const dispatch = useShopfrontDispatch();
    const onClick = () => {
        dispatch(fireEventType(LAYOUT_QUICK_MENU_TOGGLE));
    };

    return (
        <li className={"quick-menu-item" + (current ? " current" : "")}>
            {(local ? (
                <Link to={href} onClick={onClick}>
                    {children}
                </Link>
            ) : (
                <a
                    href={href}
                    rel="noopener noreferrer"
                    onClick={onClick}
                >
                    {children}
                    <sup className="external-link">
                        <FontAwesomeLight icon="external-link-square" />
                    </sup>
                </a>
            ))}
        </li>
    );
};
